import React, { useState, useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { accountService, alertService } from "../../_services";
import { util } from "../../_helpers";
import * as Yup from "yup";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-responsive-list'
import {AddEdit} from "./AddEdit";
import 'react-responsive-list/assets/index.css'

function Franchise(props) {
  let urlUsr = window.document.location.pathname.split('view/')[1];
  const user = accountService.userValue;
  
  console.log("Franchise Component loaded", urlUsr, user); // Debug logging
  
  const initialValues = {
    name: "",
    firstName: "",
    lastName: "",
    email: "",
    role: "ADMIN", // Default role for franchise
    phone: "",
    password: "",
    confirmPassword: "",
    acceptTerms: true,
    isIAM: false,
    parentUser: urlUsr?urlUsr:user.user.sub,
  };



  const [franchiseData, setFranchiseData] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedFranchiseId, setSelectedFranchiseId] = useState(null);
  
  // Add responsive states
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleFranchise = () => {
    props.showModalContent(addNewFranchise(), 'Add New Branch');
  };
   
  function fetchFranchiseData() {
    console.log("Fetching franchise data for user:", urlUsr);
    accountService.getFranchise(urlUsr)
      .then((res) => {
        console.log("Franchise data received:", res);
        const filteredData = res.filter(franchise => franchise.isIAM === false);
        setFranchiseData(filteredData);
      })
      .catch(error => {
        console.error("Error fetching franchise data:", error);
        alertService.error("Failed to load branch data");
      });
  }

  useEffect(() => {
    fetchFranchiseData();
  }, []);

  const postSuccess = () => {
    props.showModal(false);
    fetchFranchiseData();
  }



  const editFranchise = (id) => {
    let selectedFranchise = franchiseData.filter(f => f.id === id);
    return addNewFranchise(selectedFranchise[0]);
  }

  const addNewFranchise = (selFranchise) => {
    return <AddEdit parentUser={urlUsr?urlUsr:user.user.sub} onClose={postSuccess}/>
  }

  // Handle franchise deletion
  const handleDeleteClick = (franchiseId) => {
    setShowConfirm(true);
    setSelectedFranchiseId(franchiseId);
  };

  const handleConfirm = () => {
    deleteFranchise(selectedFranchiseId);
    setShowConfirm(false);
  };

  const deleteFranchise = (franchiseId) => {
    console.log('Deleting branch with ID:', franchiseId);
    accountService.deleteFranchise(franchiseId)
        .then(() => fetchFranchiseData())
        .catch((error) => alertService.error(error));
  };
  console.log(props.modalState);

  const showFranchisesList = () => {
    try {
      if (!franchiseData || franchiseData.length === 0) {
        return (
          <div className="no-data-message">
            <p>No branches found. Create a new branch to get started.</p>
          </div>
        );
      }

      return (
        <div className={isMobile ? "franchise-table-mobile" : "franchise-table-desktop"}>
          <Table
            cellPadding="5px"
            cellSpacing="3px"
            style={{ width: "100%", marginTop: "10px" }}
          >
            <Thead>
              <Tr>
                <Th style={{ width: isMobile ? "40%" : "30%" }}>Manager</Th>
                <Th style={{ width: isMobile ? "30%" : "25%" }}>Email</Th>
                <Th style={{ width: isMobile ? "0%" : "20%" }}>
                  {!isMobile && "Phone"}
                </Th>
                <Th style={{ width: isMobile ? "30%" : "25%", textAlign: "right" }}>
                  Actions
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {franchiseData.map((franchise) => (
                <Tr key={franchise.id}>
                  <Td>
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        fontSize: isMobile ? "14px" : "16px",
                        wordBreak: isMobile ? "break-word" : "normal",
                      }}
                    >
                      {`${franchise.firstName} ${franchise.lastName || ''}`}
                    </span>
                    {isMobile && franchise.phone && (
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#666",
                          marginTop: "4px",
                        }}
                      >
                        {franchise.phone}
                      </div>
                    )}
                  </Td>
                  <Td>
                    <span
                      style={{
                        fontSize: isMobile ? "13px" : "14px",
                        color: "#374151",
                        wordBreak: isMobile ? "break-all" : "normal",
                      }}
                    >
                      {franchise.email}
                    </span>
                  </Td>
                  {!isMobile && (
                    <Td>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#374151",
                        }}
                      >
                        {franchise.phone}
                      </span>
                    </Td>
                  )}
                  <Td>
                    <div
                      className={`franchise-actions}`}
                      style={{ justifyContent: "flex-end" }}
                    >
 <i style={{color:"red", cursor:"pointer", marginRight:"20px"}} class="bi bi-trash" onClick={() => handleDeleteClick(franchise.id)}></i>

                                 <i style={{ cursor:"pointer", marginRight:"20px"}} class="bi bi-pencil-fill"    onClick={async () => { 
                                      props.showModalContent(editFranchise(franchise.id), 'Edit Branch'); 
                          props.showModal(true);
                                      }
                                    }></i>

                     
                    </div>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>
      );
    } catch (err) {
      console.error("Error displaying franchise list:", err);
      return (
        <div className="error-message">
          <p>Error loading branches. Please try refreshing the page.</p>
        </div>
      );
    }
  };

  return (
    <div className="franchise-management-container">
      <div >
        <div className="personal-details-section"> 
          <div className="personal-details-header">
            <h4 className="personal-details-title">
              Branches
            </h4>
            <button
              onClick={handleFranchise}
              className="reset-password-btn"
              style={{
                padding: isMobile ? "6px 12px" : "8px 16px",
                fontSize: isMobile ? "13px" : "14px",
              }}
            >
              <i class="bi bi-plus-square" style={{ marginRight: "6px" }}></i>
              {isMobile ? "Add Branch" : "Add New Branch"}
            </button>
          </div>
          
          <div >
            <div className="franchise-list-container">
              {showFranchisesList()}
            </div>
          </div>
        </div>
      </div>
      
      {showConfirm && (
        <div className="dialog-overlay">
          <div className="dialog">
            <h3>WARNING!!</h3>
            <p>Are you sure you want to delete this branch?</p>
            <div styl={{display:"inline-block"}}>
            <button className="confirm" onClick={handleConfirm}>Yes</button>
            <button className="cancel" onClick={() => setShowConfirm(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
      
      <style jsx="true">{`
        .franchise-management-container {
          margin-bottom: 30px;
          width: 100%;
        }
        
        .franchise-list-container {
          background-color: transparent;
          border-radius: 0;
          box-shadow: none;
          overflow-x: auto;
          padding: 0;
        }
        
        .no-data-message,
        .error-message {
          padding: 20px;
          text-align: center;
          color: #666;
          background: none;
          border-radius: 8px;
          border:none;
        }
        
        .error-message {
          color: #dc2626;
          background: #fef2f2;
          border-color: #fecaca;
        }
        
        .franchise-actions {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          flex-wrap: wrap;
          padding: 12px 0;
        }
        
        .franchise-actions-mobile {
          gap: 10px;
        }
        
        .action-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 14px 24px;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          font-size: 14px;
          font-weight: 600;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          min-width: 85px;
          letter-spacing: 0.025em;
          text-decoration: none;
          position: relative;
          overflow: hidden;
        }
        
        .action-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          transition: left 0.6s;
        }
        
        .action-btn:hover::before {
          left: 100%;
        }
        
        .franchise-table-mobile .action-btn {
          padding: 10px 16px;
          min-width: 60px;
          font-size: 12px;
          gap: 6px;
        }
        
        .edit-btn {
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          color: white;
          border: 1px solid #2563eb;
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
        }
        
        .edit-btn:hover {
          background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
        }
        
        .edit-btn:active {
          transform: translateY(0);
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
        }
        
        .edit-btn i {
          font-size: 14px;
          color: white;
        }
        
        .delete-btn {
          background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
          color: white;
          border: 1px solid #dc2626;
          box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
        }
        
        .delete-btn:hover {
          background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(239, 68, 68, 0.4);
        }
        
        .delete-btn:active {
          transform: translateY(0);
          box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
        }
        
        .delete-btn i {
          font-size: 14px;
          color: white;
        }
        
        /* Table styling to match personal details */
        .franchise-list-container table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
          background: #ffffff;
          border-radius: 8px;
          overflow: hidden;
      
          border: none;
        }
        
        .franchise-list-container thead {
          background: #f8fafc;
          border-bottom: 1px solid #e5e7eb;
        }
        
        .franchise-list-container th {
          padding: 16px 20px;
          text-align: left;
          font-weight: 600;
          color: #374151;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .franchise-list-container td {
          padding: 16px 20px;
          border-bottom: 1px solid #f1f5f9;
          vertical-align: middle;
        }
        
        .franchise-list-container tbody tr {
          transition: all 0.2s ease;
        }
        
        .franchise-list-container tbody tr:hover {
          background-color: #f8fafc;
        }
        
        .franchise-list-container tbody tr:last-child td {
          border-bottom: none;
        }
        
        
      `}</style>
    </div>
  );
}

export { Franchise };